


























import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {versions} from '@/versions';

@Component({
    components: {

    }
})
export default class AppUpdateNotificationView extends BaseComponent {

    // Bindings to parent

    // Bindings to view
    public isReady = false;
    public updateExists = false;

    // Data
    public registration?: any;
    public isRefreshing = false;

    public mounted() {
        this.renderView();
    }

    private renderView() {
        // Listen for our custom event from the SW registration
        document.addEventListener('swUpdated', this.onUpdateAvailable);

        // Prevent multiple refreshes
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (this.isRefreshing) {
                return;
            }
            this.isRefreshing = true;
            // Here the actual reload of the page occurs
            window.location.reload();
        });
        this.isReady = true;
    }

    private onUpdateAvailable(event: any) {
        console.warn(event);
        event = event as CustomEvent;
        this.registration = event.detail;
        this.updateExists = true;
    }

    public refreshApp() {
        this.updateExists = false;
        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!this.registration || !this.registration.waiting) {
            return;
        }
        // send message to SW to skip the waiting and activate the new SW
        this.registration.waiting.postMessage({type: 'SKIP_WAITING'});
    }

    get version(): string {
        return versions.version;
    }

}
